<template>
  <div class="Latevents">
    <div class="newsactivity-banner">
      <div class="newsactivity-bannerbox">
        <div class="english-title-one">
          <p>LATEST </p>
          <p> ACTIVITY </p>
        </div>
        <div class="activity-text">
          最新活动
        </div>
        <div class="box-smallwhite">
          超低的价格,带来超高的享受
        </div>
      </div>
    </div>
    <div class="activity-number">
      <el-row>
        <el-col>
          <div class="activity-number-item">
            <div class="number-item-image">
              <img :src="activityList[0].picture" />
            </div>
            <div class="number-item-text-b">
              <div class="number-item-text">
                <div class="number-item-text-title">
                  <p class="nubmer">
                    <span>{{activityList[0].title}}</span>
                    <span>最新活动</span>
                  </p>
                </div>
                <div class="number-item-text-main">
                  <p class="nubmer-text">
                    {{activityList[0].description}}
                  </p>
                </div>
                <div class="small-white-box"></div>
                <div class="small-green-box"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 底部引入 -->
    <FooderContent></FooderContent>
  </div>
</template>

<script>
  import {latestEvents} from '../../api/index.js'
  import {url} from '../../config/config.js'
  import FooderContent from '../components/fooder.vue'
  export default {
    components: {
      FooderContent
    },
    created() {
      //最新活动
      latestEvents()
      .then(res=>{
        res.data.data.map(activityList=>{
          activityList.picture = url + activityList.picture
        })
        this.activityList=res.data.data
        console.log(this.activityList)
      })
      .catch(err=>{
        alert('错误信息：'+err.msg)
      })
    },
    data(){
      return{
        activityList:[],
      }
    }
  }
</script>

<style>
  /* activity-banner start */
  .newsactivity-banner {
    width: 100%;
    display: inline-block;
    min-width: 100%;
    max-width: 100%;
    height: auto;
    height: 48.5rem;
    background-image: url(../assets/activity-image/activityimage.png);
    background-size: 100% 100%;
    position: relative;
  }

  .newsactivity-bannerbox {
    width: 34.25rem;
    height: 36.125rem;
    margin-left: 23.375rem;
    background-image: url(../assets/activity-image/smallbackgroud.png);
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }

  .activity-text {
    width: 233px;
    height: 16.125rem;
    font-size: 5.4375rem;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #FFFFFF;
    opacity: 1;
    position: absolute;
    top: 4.75rem;
    right: 0.75rem;
    letter-spacing: 1.25rem;
  }

  .english-title-one {
    width: 28.5625rem;
    height: 15.1875rem;
    margin-top: 9.125rem;
    margin-left: 2.8125rem;
    margin-right: 2.875rem;
  }

  .english-title-one p {
    font-size: 72px;
    font-family: Source Han Sans SC;
    font-weight: 800;
    line-height: 68px;
    color: #0A9F93;
    opacity: 0.58;
    padding: 13px 0px;
  }

  .english-title-one p:nth-child(2) {
    float: right;
    margin: 0;
  }

  .box-smallwhite {
    width: 25.5625rem;
    height: 3.75rem;
    line-height: 3.75rem;
    padding-left: 1.0625rem;
    background-color: #FFFFFF;
    margin: 0 auto;
    font-size: 1.5rem;
    color: #27CBBD;
    margin-top: 30px;

  }

  /* activity-banner end */
  /* activity-number start */
  .activity-number-item {
    width: 100rem;
    height: 34rem;
    margin: 7.0625rem auto;
    /* background-color: #27CBBD; */
    position: relative;
  }

  .number-item-image {
    width: 60.4375rem;
    height: 100%;
    background-size: 100% 100%;
    float: left;
    overflow: hidden;
  }

  .number-item-image img {
    width: 100%;
    height: auto;
    transition: all 0.5s linear;
  }
  .number-item-image img:hover {
    cursor: default;
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    -ms-transform: scale(1.2);
    -o-transform: scale(1.2);
    transform: scale(1.2);
  }
  .number-item-text-b {
    width: 39.5rem;
    height: 34rem;
    float: left;
    background-color: #27CBBD;
  }

  .number-item-text {
    width: 30rem;
    height: 30rem;
    overflow: auto;
    float: left;
    margin-left: 1.25rem;
    overflow: hidden;
  }
  .number-item-text :hover {
    /* x=-10px代表左移10px */
    transform: translateX(3px);
    /* 0.4s完成transform移动效果*/
    transition: transform 0.4s;
  }
  .number-item-text-title {
    width: 100%;
    height: 10rem;
    margin-top: 3.25rem;
  }

  .number-item-text-main {
    width: 100%;
    height: 10rem;
    margin-top: 1.25rem;
  }

  .nubmer-text {
    color: white;
    font-size: 1.3rem;
  }

  .nubmer {

    margin-top: 3.875rem;
    float: left;
  }

  .nubmer span:first-child {
    font-size: 5rem;
    font-family: Source Han Sans SC;
    line-height: 30px;
    color: #FFFFFF;
    opacity: 1;
    padding-right: 0.9375rem;
    text-align: center;
  }

  .nubmer span:nth-child(2) {
    font-size: 36px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 30px;
    color: #FFFFFF;
    opacity: 1;
    margin-top: -0.2rem;
  }

  .small-white-box {
    width: 4.125rem;
    height: 4.125rem;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -2.0625rem;
    background-color: white;
  }

  .small-green-box {
    width: 4.125rem;
    height: 4.125rem;
    position: absolute;
    top: 50%;
    right: -4.125rem;
    margin-top: -2.0625rem;
    background-color: white;
    background-color: #38AB6D;
  }

  @media screen and (max-width: 100rem) {
    .newsactivity-banner {
      width: 100%;
      display: inline-block;
      min-width: 118rem;
      max-width: 100%;
      height: auto;
      height: 48.5rem;
      background-image: url(../assets/activity-image/activityimage.png);
      background-size: 100% 100%;
      position: relative;

    }

    .newsactivity-bannerbox {
      width: 34.25rem;
      height: 36.125rem;
      margin-left: 23.375rem;
      background-image: url(../assets/activity-image/smallbackgroud.png);
      background-size: 100% 100%;
      position: absolute;
      bottom: 0;
    }

    .activity-text {
      width: 233px;
      height: 16.125rem;
      font-size: 5.4375rem;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      opacity: 1;
      position: absolute;
      top: 4.75rem;
      right: 0.75rem;
      letter-spacing: 1.25rem;
    }

    .english-title-one {
      width: 28.5625rem;
      height: 15.1875rem;
      margin-top: 9.125rem;
      margin-left: 2.8125rem;
      margin-right: 2.875rem;
    }

    .english-title-one p {
      font-size: 72px;
      font-family: Source Han Sans SC;
      font-weight: 800;
      line-height: 68px;
      color: #0A9F93;
      opacity: 0.58;
      padding: 13px 0px;
    }

    .activity-number-item {
      width: 100rem;
      height: 34rem;
      margin: 7.0625rem auto;
      /* background-color: #27CBBD; */
      position: relative;
      margin-left: 124px;
    }

    .box-smallwhite {
      width: 25.5625rem;
      height: 3.75rem;
      line-height: 3.75rem;
      padding-left: 1.0625rem;
      background-color: #FFFFFF;
      margin: 0 auto;
      font-size: 1.5rem;
      color: #27CBBD;
      margin-top: 30px;

    }

    .number-item-image {
      width: 60.4375rem;
      height: 100%;
      background-size: 100% 100%;
      float: left;
    }

    .number-item-text-b {
      width: 39.5rem;
      height: 34rem;
      float: left;
      background-color: #27CBBD;

    }

    .number-item-text {
      width: 30rem;
      height: 30rem;
      overflow: auto;
      float: left;
      margin-left: 1.25rem;
    }

    .number-item-text-title {
      width: 100%;
      height: 10rem;
      margin-top: 3.25rem;
    }

    .nubmer-text {
      color: white;
      font-size: 1.3rem;
    }

    .nubmer {

      margin-top: 3.875rem;
      float: left;
    }

    .nubmer span:first-child {
      font-size: 5rem;
      font-family: Source Han Sans SC;
      line-height: 30px;
      color: #FFFFFF;
      opacity: 1;
      padding-right: 0.9375rem;
      text-align: center;
    }

    .nubmer span:nth-child(2) {
      font-size: 36px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 30px;
      color: #FFFFFF;
      opacity: 1;
      margin-top: -0.2rem;
    }

    .number-item-text-main {
      width: 100%;
      height: 10rem;
      margin-top: 1.25rem;
    }

    .small-white-box {
      width: 4.125rem;
      height: 4.125rem;
      position: absolute;
      top: 50%;
      right: 0;
      margin-top: -2.0625rem;
      background-color: white;
    }

    .small-green-box {
      width: 4.125rem;
      height: 4.125rem;
      position: absolute;
      top: 50%;
      right: -4.125rem;
      margin-top: -2.0625rem;
      background-color: white;
      background-color: #38AB6D;
    }
  }

  @media screen and (max-width: 62rem) {
    .newsactivity-banner {
      width: 100%;
      display: inline-block;
      max-width: 100%;
      min-width: 19rem;
      height: auto;
      height: 19rem;

    }

    .newsactivity-bannerbox {
      width: 15.25rem;
      height: 16.125rem;
      margin-left: 4.375rem;
      background-image: url(/img/smallbackgroud.bc009514.png);
      background-size: 100% 100%;
      position: absolute;
      bottom: -17px;
    }

    .activity-text {
      width: 156px;
      height: 9.125rem;
      font-size: 2.4375rem;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      opacity: 1;
      position: absolute;
      top: 1.5rem;
      right: -2rem;
      letter-spacing: 1.25rem;
    }

    .english-title-one {
      width: 13.5625rem;
      height: 7.1875rem;
      margin-top: 3.4rem;
      margin-left: 0.8125rem;
      margin-right: 2.875rem;
    }

    .english-title-one p {
      font-size: 30px;
      font-family: Source Han Sans SC;
      font-weight: 800;
      line-height: 15px;
      color: #0A9F93;
      opacity: 0.58;
      padding: 13px 0px;
    }

    .activity-number-item {
      width: 100%;
      min-width: 23rem;
      max-width: 100%;
      height: 12.5rem;
      margin: 7.0625rem auto;
      background-color: #27CBBD;
      position: relative;
    }

    .box-smallwhite {
      width: 10.5625rem;
      height: 2rem;
      line-height: 1.75rem;
      padding-left: 1.0625rem;
      background-color: #FFFFFF;
      margin: 0 auto;
      font-size: 12px;
      color: #27CBBD;
      margin-top: 12px;

    }

    .number-item-image {
      width: 100%;
      display: contents;
      min-width: 23rem;
      max-width: 100%;
      height: 100%;
      background-size: 100% 100%;
      float: left;
    }

    .number-item-text-b {
      width: 100%;
      min-width: 20rem;
      max-width: 100%;
      height: 14rem;
      float: left;
      background-color: #27CBBD;
      margin-bottom: 5rem;

    }

    .number-item-text {
      width: 35rem;
      height: 12rem;
      overflow: auto;
      float: left;
      margin-left: 1.25rem;
    }

    .number-item-text-title {
      width: 100%;
      height: 2rem;
      margin-top: 3.25rem;
    }

    .nubmer {

      margin-top: -0.125rem;
      float: left;
    }

    .nubmer-text {
      color: white;
      font-size: 1rem;
    }

    .nubmer span:first-child {
      font-size: 2rem;
      font-family: Source Han Sans SC;
      line-height: 0px;
      color: #FFFFFF;
      opacity: 1;
      padding-right: 0.9375rem;
      text-align: center;
    }

    .nubmer span:nth-child(2) {
      font-size: 24px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 30px;
      color: #FFFFFF;
      opacity: 1;
      margin-top: -0.2rem;
    }

    .number-item-text-main {
      width: 35rem;
      height: 5rem;
      margin-top: 1.25rem;
    }

    .small-white-box {
      width: 2.125rem;
      height: 2.125rem;
      position: absolute;
      top: 140%;
      right: 46px;
      margin-top: -2.0625rem;
      background-color: white;
      display: none;
    }

    .small-green-box {
      width: 2.125rem;
      height: 2.125rem;
      position: absolute;
      top: 140%;
      right: 0.875rem;
      margin-top: -2.0625rem;
      background-color: white;
      background-color: #38AB6D;
      display: none;
    }
  }

  @media screen and (max-width: 48rem) {
    .newsactivity-banner {
      width: 100%;
      display: inline-block;
      max-width: 100%;
      min-width: 19rem;
      height: auto;
      height: 19rem;

    }

    .newsactivity-bannerbox {
      width: 15.25rem;
      height: 16.125rem;
      margin-left: 4.375rem;
      background-image: url(/img/smallbackgroud.bc009514.png);
      background-size: 100% 100%;
      position: absolute;
      bottom: -17px;
    }

    .activity-text {
      width: 53%;
      height: 7.125rem;
      font-size: 2.5rem;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #FFFFFF;
      opacity: 1;
      position: absolute;
      top: 2rem;
      right: 0rem;
      letter-spacing: 1.25rem;
    }

    .english-title-one {
      width: 13.5625rem;
      height: 7.1875rem;
      margin-top: 3.4rem;
      margin-left: 0.8125rem;
      margin-right: 2.875rem;
    }

    .english-title-one p {
      font-size: 30px;
      font-family: Source Han Sans SC;
      font-weight: 800;
      line-height: 15px;
      color: #0A9F93;
      opacity: 0.58;
      padding: 13px 0px;
    }

    .activity-number-item {
      width: 99%;
      min-width: 16rem;
      max-width: 100%;
      height: 11rem;
      margin: 7.0625rem auto;
      background-color: #27CBBD;
      position: relative;

    }

    .box-smallwhite {
      width: 10.5625rem;
      height: 2rem;
      line-height: 1.75rem;
      padding-left: 1.0625rem;
      background-color: #FFFFFF;
      margin: 0 auto;
      font-size: 12px;
      color: #27CBBD;
      margin-top: 12px;

    }

    .number-item-image {
      width: 100%;
      min-width: 19.5rem;
      max-width: 19rem;
      height: 100%;
      background-size: 100% 100%;
      float: left;
      overflow: hidden;
    }
    .number-item-image img{
      overflow: hidden;
      transition: all 0.5s linear;
    }
    .number-item-text-b {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      height: 14rem;
      float: left;
      background-color: #27CBBD;
      margin-bottom: 5rem;

    }

    .number-item-text {
      width: 100%;
      min-width: 100%;
      height: 12rem;
      overflow: auto;
      float: left;
      margin-left: 0rem;
    }

    .number-item-text-title {
      width: 94%;
      height: 2rem;
      margin-top: 3.25rem;
      margin-left: 1rem
    }

    .nubmer {

      margin-top: -0.125rem;
      float: left;
    }

    .nubmer-text {
      color: white;
      font-size: 0.3rem;
    }

    .nubmer span:first-child {
      font-size: 2rem;
      font-family: Source Han Sans SC;
      line-height: 0px;
      color: #FFFFFF;
      opacity: 1;
      padding-right: 0.9375rem;
      text-align: center;
    }

    .nubmer span:nth-child(2) {
      font-size: 24px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 30px;
      color: #FFFFFF;
      opacity: 1;
      margin-top: -0.2rem;
    }

    .number-item-text-main {
      width: 18rem;
      height: 5rem;
      margin-top: 1.25rem;
      margin-left: 1rem;

    }

    .small-white-box {
      width: 2.125rem;
      height: 2.125rem;
      position: absolute;
      top: 140%;
      right: 46px;
      margin-top: -2.0625rem;
      background-color: white;
      display: none;
    }

    .small-green-box {
      width: 2.125rem;
      height: 2.125rem;
      position: absolute;
      top: 140%;
      right: 0.875rem;
      margin-top: -2.0625rem;
      background-color: white;
      background-color: #38AB6D;
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Latevents.vue